<template>
  <div class="head">
    <div class="headBox flex align-center justify-between">
      <div class="headLeft"></div>
      <div class="headRight">
        <div class="head-btn" @click="to('/orghome')">
          <i class="iconfont icon-wode"></i> 个人中心
        </div>
        <div class="head-btn" @click="sginout">
          <i class="iconfont icon-exit-full"></i> 退出登录
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "headerpage",
  data() {
    return {

    }
  },
  components: {},
  computed: {
    user() {
      // return this.$store.state.user
      return {organ_name:''}
    },
  },
  created() {

  },
  methods: {
    sginout() {
      this.$confirm(
        '您确定要退出吗？',
        '温馨提示', {
          confirmButtonText: '确定',
          type: 'warning',
          closeOnClickModal: false,
          closeOnPressEscape: false,
        }
      ).then(() => {
        this.$store.dispatch('LogOut').then(() => {
          this.$router.replace('/orglogin')
        })
      })
    },
    // 跳转
    to(path) {
      this.$router.push(path)
    },
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.head {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .headBox {
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .headLeft {

    }

    .headRight {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .head-btn {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;
        font-size: 14px;
        color: #ffffff;
        margin-left: 20px;
        i {
          font-size: 16px;
          color: #ffffff;
          margin-right: 4px;
        }
      }
    }
  }
}

</style>


